export const LogoMark = ({ className = "" }) => (
  <img src="/favicon.png" alt="" aria-hidden="true" className={`rounded-full ${className}`} />
);

export const Logo = ({ onClick, testid = "brand-logo" }) => (
  <a href="/" onClick={onClick} data-testid={testid} className="group flex items-center" aria-label="AURA">
    <img src="/img/logo-wordmark-dark.png" alt="AURA" className="h-[72px] w-auto transition-opacity duration-500 group-hover:opacity-75 md:h-20" />
  </a>
);
